import { Controller } from "@hotwired/stimulus"

// QR-Login der App: nimmt das Scanner-Ergebnis ({token, env} als JSON), prüft die Umgebung gegen das
// <meta name="current-environment"> des Layouts und schickt das Token an /mobile_app/qr_code_sign_in.
//
// Connects to data-controller="qr-sign-in"
export default class extends Controller {
  static targets = ["form", "error"]

  signIn({ detail: { content } }) {
    console.log("aaaa", this.submitted)
    if (this.submitted) return

    const payload = this.parse(content?.data)
    if (!payload?.token) return

    const currentEnvironment = document.querySelector('meta[name="current-environment"]')?.content
    if (payload.env && currentEnvironment && payload.env !== currentEnvironment) {
      this.showError(`QR-Code stammt von "${payload.env}", diese App zeigt auf "${currentEnvironment}".`)
      return
    }

    this.submitted = true
    this.formTarget.querySelector('input[name="sign_in_token"]').value = payload.token
    this.dispatch("done")
    this.formTarget.requestSubmit()
  }

  parse(text) {
    try {
      return JSON.parse(text)
    } catch {
      return null
    }
  }

  showError(message) {
    if (!this.hasErrorTarget) return

    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("d-none")
  }
}
